export function getApiErrorMessage(err) {
  const data = err?.response?.data;

  if (typeof data === "string") return data;
  if (typeof data?.message === "string") return data.message;
  if (Array.isArray(data?.message)) return data.message.join(", ");

  if (data?.message && typeof data.message === "object") {
    return Object.entries(data.message)
      .map(([key, value]) =>
        `${key}: ${Array.isArray(value) ? value.join(", ") : String(value)}`
      )
      .join(" | ");
  }

  if (typeof data?.error === "string") return data.error;
  if (typeof err?.message === "string") return err.message;

  return "Failed to process request";
}